import { render, staticRenderFns } from "./ApprovedPage.vue?vue&type=template&id=713d39ba&"
import script from "./ApprovedPage.vue?vue&type=script&lang=js&"
export * from "./ApprovedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports